'use strict';
const angular = require('angular');

import { ISeason } from '../../interfaces';

/**
 * List of emails of all the members in displayed on admin baskets
 */
export class adminBasketExportEmailsComponent {
  $http: ng.IHttpService;
  $stateParams: any;
  members: any;
  textOfEmails: string;
  season: ISeason;

  /*@ngInject*/
  constructor($http, $stateParams) {
    this.$http = $http;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.textOfEmails = 'First Name,Last Name,Email\n';
    let resolve = (this as any).resolve;

    // Get the season parameter
    if (_.has(resolve, 'season') && resolve.season !== null) {
      this.season = resolve.season;
    } else {
      this.back();
    }

    let scope = this;
    
    scope.$http.get("/api/baskets/bySeasonForEmails/"+scope.season._id)
    .then(res => {
      let data = (res.data as any);
      let members = data.members;
      let users = data.users;
      let emailsBackup = new Array();

      // Add the member email
      members.forEach(member => {
        let user = users.find(user => user.membership == member._id);
        if (user) {
          let email = user.email;
          emailsBackup.push(email);
          scope.textOfEmails += member.firstName +','+ member.lastName +','+ email +'\n';
        }
      });

      // Add the extra email if they are not already included
      data.extraEmails.forEach(email => {
        if (!emailsBackup.includes(email)) {
          scope.textOfEmails += ',,'+ email +'\n';
        }
      });
    });
  }

  back() {
    (this as any).close();
  };
}


export default angular.module('terrappApp.adminBaskets')
  .component('adminBasketExportEmails', {
    template: require('./adminBasketExportEmails.html'),
    controller: adminBasketExportEmailsComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;


// WEBPACK FOOTER //
// ./client/app/admin/adminBaskets/adminBasketExportEmails.component.ts